import type {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'

import { AUTH_COOKIE, USER_INFO_COOKIE } from '@/utils/constants'

export async function authInterceptorRequest(
  config: InternalAxiosRequestConfig,
) {
  if (typeof window === 'undefined') {
    const { cookies } = await import('next/headers')
    const token = cookies().get(AUTH_COOKIE)?.value

    if (token) {
      Object.assign(config.headers || {}, {
        authorization: `Bearer ${token}`,
      })
    }

    return config
  }

  const Cookies = (await import('js-cookie')).default
  const token = Cookies.get(AUTH_COOKIE)

  if (token) {
    Object.assign(config.headers || {}, {
      authorization: `Bearer ${token}`,
    })
  }

  return config
}

export async function authInterceptorResponse(response: AxiosResponse) {
  return response
}

export async function authInterceptorResponseError(error: AxiosError) {
  if (error.response?.status === 401) {
    if (typeof window === 'undefined') {
      // No lado do servidor, apenas retornamos o erro
      // O middleware de autenticação já cuida do redirecionamento
      return Promise.reject(error)
    } else {
      // Client-side
      const Cookies = (await import('js-cookie')).default
      Cookies.remove(AUTH_COOKIE)
      Cookies.remove(USER_INFO_COOKIE)
      window.location.href = '/login'
    }
  }
  return Promise.reject(error)
}
